import { sessionConnector } from 'shared/connectors'
import { SESSION } from 'store/types'

const success = data => ({
  type: SESSION.GET_CATEGORIES_OPTIONS_SUCCESS,
  payload: {
    data,
  },
})

const failure = () => ({
  type: SESSION.GET_CATEGORIES_OPTIONS_FAILURE,
})

const getCategoriesOptions = () => async dispatch => {
  try {
    const { data } = await sessionConnector.getCategoriesOptions()
    dispatch(success(data))
  } catch (err) {
    dispatch(failure())
  }
}

export default getCategoriesOptions
